import { render, staticRenderFns } from "./check-subject.vue?vue&type=template&id=04cf95e8&scoped=true&"
import script from "./check-subject.vue?vue&type=script&lang=js&"
export * from "./check-subject.vue?vue&type=script&lang=js&"
import style0 from "./check-subject.vue?vue&type=style&index=0&id=04cf95e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf95e8",
  null
  
)

export default component.exports